import { __read, __values } from "tslib";
import { QueryExpType, equalsKeyPaths, } from '@tencent/memoire-core';
/**
 * QueryBinder bind schema to query conditions
 */
var QueryBinder = /** @class */ (function () {
    function QueryBinder(schema) {
        this.schema = schema;
        this.indicesMap = new Map();
        this.warmupIndicesMap();
    }
    /**
     * Add hints to query expression according to collection schema
     * Change path to alias name if has set
     * @param conditions the query conditions to be hinted
     */
    QueryBinder.prototype.bind = function (conditions) {
        this.bindQueryHints(conditions.exp);
        return conditions;
    };
    QueryBinder.prototype.bindQueryHints = function (queryExp) {
        var _this = this;
        var _a;
        var exp = queryExp;
        if (exp.type === QueryExpType.AND || exp.type === QueryExpType.OR) {
            exp.exps.forEach(function (exp) { return _this.bindQueryHints(exp); });
            return;
        }
        if (exp.type === QueryExpType.FILTER) {
            exp.hints.isKey = this.schema.key && equalsKeyPaths(this.schema.key.path, exp.path);
            exp.hints.indices = (_a = this.indicesMap.get(exp.path)) !== null && _a !== void 0 ? _a : [];
        }
    };
    QueryBinder.prototype.warmupIndicesMap = function () {
        var e_1, _a, e_2, _b;
        var _c;
        try {
            for (var _d = __values(this.schema.indices.entries()), _e = _d.next(); !_e.done; _e = _d.next()) {
                var _f = __read(_e.value, 2), order = _f[0], index = _f[1];
                // mark default priority to be the opposite number of index declaration order
                index.priority = (_c = index.priority) !== null && _c !== void 0 ? _c : -(order + 1);
                var paths = Array.isArray(index.path) ? index.path : [index.path];
                try {
                    for (var paths_1 = (e_2 = void 0, __values(paths)), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()) {
                        var path = paths_1_1.value;
                        var indices = this.indicesMap.get(path) || [];
                        indices.push(index);
                        this.indicesMap.set(path, indices);
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (paths_1_1 && !paths_1_1.done && (_b = paths_1.return)) _b.call(paths_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            }
            finally { if (e_1) throw e_1.error; }
        }
    };
    return QueryBinder;
}());
export default QueryBinder;
//# sourceMappingURL=query-binder.js.map